import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import axios from '../../../API/axios';
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';
import { ShimmerDiv } from 'shimmer-effects-react';
import { Token } from '@mui/icons-material';
import toast from "react-hot-toast";
import CompanyInteraction from "../../FollowedCompanies/CompanyInteraction";
import { Button, Modal } from 'react-bootstrap';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import error from "../../../assets/images/Not-Found.png";




const AllCompanies = ({ Compuid }) => {
	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem('userType')
	const token = localStorage.getItem('token')

	const [showModal, setShowModal] = useState(false);
	const [institutes, setInstitutes] = useState([]);
	const [hasMoreData, setHasMoreData] = useState(true);
	const [userList, setUserList] = useState([]);
	const [searchuserList, setSearchuserList] = useState([]);

	const [loading, setLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [page, setPage] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [jobList, setcmpnyList] = useState([]);
	const [searchcmpnyList, setSearchCmpnyList] = useState([]);
	const [searchcmpnyName, setSearchCmpnyName] = useState("");
	const [companyId, setCompanyId] = useState("");

	const [isFollowing, setIsFollowing] = useState(false);
	console.log("companyId", companyId);

	const [isError, setIsError] = useState(false);
	const [reset, setReset] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [nextBatchLoading, setNextBatchLoading] = useState('')
	console.log("searchuserList", searchuserList);

	// const getAllCompanyList = (page, searchcmpnyName) => {
	// 	setNextBatchLoading(true);
	// 	setIsLoading(true);
	// 	const data = {
	// 		pageNumber: page,
	// 		pageSize: 10
	// 	}

	// 	axios
	// 		.post(`/Company/GetAll?CompType=Company&Search=${searchcmpnyName}`, data)
	// 		.then((response) => {
	// 			const res = response.data.responseData.companyList;
	// 			console.log("getAllCompanyList", response.data.responseData.companyList);
	// 			setcmpnyList(res);
	// 			setIsLoading(false);
	// 			// setTotalPages(response.data.responseData.paging.totalPages);

	// 			const newPosts = response.data.responseData.companyList;
	// 			// console.log("newwwwposttt", newPosts);

	// 			if (searchcmpnyName !== '') {
	// 				setcmpnyList([])
	// 				setSearchCmpnyList(newPosts)
	// 			} else {
	// 				setSearchCmpnyList([])
	// 				setcmpnyList((prev) => {
	// 					const jobSet = new Set(prev?.map((job) => job?.uid));
	// 					const uniqueNewPosts = newPosts.filter(
	// 						(job) => !jobSet.has(job?.uid)
	// 					);
	// 					return [...prev, ...uniqueNewPosts];
	// 				});
	// 			}
	// 		})
	// 		.catch((error) => {
	// 			if (error.response && error.response.status === 404) {
	// 				setIsError(true);
	// 			} else {
	// 				console.log(error);
	// 			}
	// 			setIsLoading(false);
	// 			setNextBatchLoading(false);
	// 		});
	// };
	// useEffect(() => {
	// 	if (page <= totalPages) {
	// 		getAllCompanyList(page + 1);
	// 	}
	// }, [page]);

	// useEffect(() => {
	// 	setcmpnyList([]); // Reset job list when searchcmpnyName changes
	// 	getAllCompanyList(1, searchcmpnyName); // Start from page 1 for a new search
	// }, [searchcmpnyName]);


	const getAllCompanyList = (page, searchUserName) => {
		setNextBatchLoading(true);
		const data = {
			pageNumber: page,
			pageSize: 10,
		};
		axios
			.post(`/Company/GetAll?CompType=Company&Search=${institutes}`, data)
			.then((response) => {
				setIsLoading(false);
				console.log("people res", response);

				const totalPages = response.data.responseData.paging.totalPages;
				setTotalPages(totalPages);
				if (page >= response.data.responseData.paging.totalPages) {
					setHasMoreData(false);
				}
				const newPosts = response.data.responseData.companyList;
				if (newPosts.length === 0) {
					setIsError(true)
				} else {
					setIsError(false)
				}

				if (searchUserName !== '') {
					// return newPosts;
					setUserList([])
					setSearchuserList(newPosts)
				} else {
					setSearchuserList([])
					setUserList((prev) => {
						const userSet = new Set(prev?.map((user) => user?.userUid));
						const uniqueNewPosts = newPosts.filter(
							(user) => !userSet.has(user?.userUid)
						);
						return [...prev, ...uniqueNewPosts];
					});
				}

				if (page >= totalPages) {
					setNextBatchLoading(false); // Stop loading if the last page is reached
				} else {
					setNextBatchLoading(false); // Continue loading for more pages
				}

				console.log("all post data", newPosts);
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					setIsError(true);
				} else {
					console.log(error);
				}
				setIsLoading(false);
				setNextBatchLoading(false);
			});
	};

	useEffect(() => {
		setUserList([]); // Reset user list when searchUserName changes
		getAllCompanyList(1, institutes); // Start from page 1 for a new search
	}, [institutes]);

	useEffect(() => {
		if (page <= totalPages) {
			getAllCompanyList(page, institutes);
		}
	}, [page]);
	
	const handleInfiniteScroll = async () => {
		try {
			if (window.innerHeight + document.documentElement.scrollTop + 1 >=
				document.documentElement.scrollHeight) {
				setLoading(true);
				console.log('log', page, totalPages);

				page < totalPages && setPage((prev) => prev + 1);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleInfiniteScroll);
		return () => window.removeEventListener("scroll", handleInfiniteScroll);
	}, []);

	//************************ Follow Company Start  ************************//

	const FollowCompany = async (id) => {
		console.log("Follow Company ID:", id);

		const data = {
			sessionId: sessionId,
			compUID: id, // Pass the correct ID
		};

		try {
			const response = await axios.post("/CandidateAction/FollowCompany", data);
			console.log("Follow response:", response.data.message);

			// Update the following state for this specific company
			setIsFollowing((prev) => ({
				...prev,
				[id]: true, // Update state for this company
			}));

			toast.success(response.data.message);
		} catch (e) {
			console.error("Follow error:", e.response?.data?.message || e.message);
			toast.error(e.response?.data?.message || "Error while following");
		}
	};

	//************************ Follow Company End  ************************//

	//************************ UnFollow Company Start  ************************//
	const [showUnfollowModal, setshowUnfollowModal] = useState(false);
	const handleCloseModal = () => setshowUnfollowModal(false);
	const handleShow = () => setshowUnfollowModal(true);
	// const UnFollow = async () => {
	// 	const data = {
	// 		sessionId: sessionId,
	// 		compUID: companyId,

	// 	};
	// 	console.log("data", data);

	// 	try {
	// 		await axios.post("/CandidateAction/UnfollowCompany", data).
	// 			then((resData) => {
	// 				console.log("resData", resData.data.message);
	// 				toast.success(resData.data.message)
	// 				setIsFollowing(false); // Update state to show Follow button
	// 				handleCloseModal();

	// 			});
	// 	} catch (e) {
	// 		if (e.response && e.response.status === 404) {
	// 			toast.error(e.response.data.message);
	// 		} else {
	// 			toast.error(e.response.data.message);
	// 		}
	// 	}
	// };

	const UnFollow = async (id) => {
		console.log("Unfollow Company ID:", id);

		const data = {
			sessionId: sessionId,
			compUID: id, // Pass the correct ID
		};

		try {
			const response = await axios.post("/CandidateAction/UnfollowCompany", data);
			console.log("Unfollow response:", response.data.message);

			// Update the following state for this specific company
			setIsFollowing((prev) => ({
				...prev,
				[id]: false, // Update state for this company
			}));

			toast.success(response.data.message);
		} catch (e) {
			console.error("Unfollow error:", e.response?.data?.message || e.message);
			toast.error(e.response?.data?.message || "Error while unfollowing");
		}
	};


	const handleConfirmUnfollow = () => {
		// UnFollow(companyId); // Pass the specific company ID
		UnFollow();
		handleCloseModal()

	};
	//************************ UnFollow Company End  ************************//

	console.log("searchcmpnyList", searchcmpnyList);

	return (
		<>
			<div className="pt-70">
				<section className={`inner-employer-section PeopleSearch pt-2`}>
					<div className="container">
						<Tabs className="cl8 tf-tab jobcontent">
							<Row>
								<div className="wd-meta-select-job">
									<div className="wd-findjob-filer candidateSearch">
										<div className="group-select-display"></div>
										<div className="form-group-1" style={{ borderRadius: "6px"}}>
											<input
												type="email"
												className="form-control p-2 Dark-Input-from-group"
												style={{ borderRadius: "6px" }}
												id="exampleInputEmail1"
												aria-describedby="emailHelp"
												placeholder="Search Company"
												onChange={(e) => {
													setInstitutes(e.target.value);
													getAllCompanyList();
												}}
												value={institutes}
											/>
										</div>
									</div>
								</div>
							</Row>

							<div className="content-tab">
								{/* Tab content for employer listings */}
								<TabPanel
									className="inner"
									style={{
										minHeight: isLoading || nextBatchLoading ? '600px' : 'auto',
										height: 'auto',
									}}
								>
									<div className="Search-job-group row ">
										{isLoading ? (
											<div className="row mt-2">
												{[...Array(6)].map((_, i) => (
													<div key={i} className="col-md-4 mt-2">
														<ShimmerDiv mode="light" height={100} width="100%" />
													</div>
												))}
											</div>
										) : isError ? (
											<div className="mt-6 d-flex justify-content-center">
												<img src={error} alt="404 Not Found" width={300} />
											</div>
										) : searchuserList.length === 0 && userList.length > 0 ? (
											userList.map((company, index) => (
												<div key={company.compUid} className="employer-block Institue-cards-block style-2 cl2 col-md-4 Institue-cards-allcompanines" >

													<div className="inner-box">
														<div className="logo-company">
															<img src={company.logoImage} alt="User Logo" />
														</div>
														<div className="box-content">
															<div className="star">{/* Star ratings */}</div>
															<h3>
																{token === null ? (
																	company.name
																) : company.compType === "Company" ? (
																	<Link to={`/Company/${company.uid}`}>
																		{company.name}
																	</Link>
																) : (
																	<Link to={`/Recruiter/${company.uid}`}>
																		{company.name}
																	</Link>
																)}
															</h3>
															{company.cityName === null ? '' : (
																<>
																	<p className="info">
																		<span className="icon-map-pin me-2"></span>
																		{company.cityName}
																	</p>
																</>
															)}


														</div>


														{token === null ? (
															""
														) : (
															<>
																<CompanyInteraction Compuid={company.uid}
																	getCompanyList={getAllCompanyList}
																	isBlocked={company.isBlocked} isFollowed={company.isFollowed} />

															</>
														)
														}

													</div>
												</div>
											))
										) : (
											searchuserList.map((company, index) => (
												<div key={company.compUid} className="employer-block Institue-cards-block style-2 cl2 col-xl-6 col-md-6  Institue-cards-allcompanines" >
													{
														company.compType === "Company" ? (
															<Link to={`/Company/${company.uid}`}>
																<div className="inner-box">
																	<div className="logo-company">
																		<img src={company.logoImage} alt="User Logo" />
																	</div>
																	<div className="box-content">
																		<div className="star"></div>
																		<h3>
																			{token === null ? (
																				company.name
																			) : company.compType === "Company" ? (
																				<Link to={`/Company/${company.uid}`}>
																					{company.name}
																				</Link>
																			) : (
																				<Link to={`/Recruiter/${company.uid}`}>
																					{company.name}
																				</Link>
																			)}
																		</h3>
																		{company.cityName === null ? '' : (
																			<>
																				<div>
																					<p className="info me-4">
																						<span className="icon-map-pin me-2"></span>
																						{company.cityName}
																					</p>
																				</div>

																			</>
																		)}

																		<div className='d-flex'>
																			{company.compType ? (
																				<p onClick={(e) => { e.preventDefault() ;
																					e.stopPropagation(); }
																				}
																				className="info me-2 allcompanines-info">
																					{company.compType}
																				</p>
																			) : null}

																			{company.companyCategory ? (
																				<p onClick={(e) => { e.preventDefault() ;
																					e.stopPropagation(); }
																				}
																				className="info me-2 allcompanines-info">
																					{company.companyCategory}
																				</p>
																			) : null}

																			{company.companySize ? (
																				<p onClick={(e) => { e.preventDefault() ;
																					e.stopPropagation(); }
																				}
																				className="info me-2 allcompanines-info">
																					{company.companySize}
																				</p>
																			) : null}
																		</div>
																	</div>


																	{token === null ? (
																		""
																	) : (
																		<>
																			<div
																				onClick={(e) => {
																					e.preventDefault();
																					e.stopPropagation();
																				}}
																			>
																				<CompanyInteraction Compuid={company.uid}
																					getCompanyList={getAllCompanyList}
																					isBlocked={company.isBlocked} isFollowed={company.isFollowed} />
																			</div>


																		</>
																	)
																	}

																</div>
															</Link>
														) : (
															<>
																<Link to={`/Recruiter/${company.uid}`}>
																	<div className="inner-box">
																		<div className="logo-company">
																			<img src={company.logoImage} alt="User Logo" />
																		</div>
																		<div className="box-content">
																			<div className="star"></div>
																			<h3>
																				{token === null ? (
																					company.name
																				) : company.compType === "Company" ? (
																					<Link to={`/Company/${company.uid}`}>
																						{company.name}
																					</Link>
																				) : (
																					<Link to={`/Recruiter/${company.uid}`}>
																						{company.name}
																					</Link>
																				)}
																			</h3>
																			{company.cityName === null ? '' : (
																				<>
																					<div>
																						<p className="info me-4">
																							<span className="icon-map-pin me-2"></span>
																							{company.cityName}
																						</p>
																						<p className="info">
																							<span className=""></span>
																							{company.compType}
																						</p>
																					</div>

																				</>
																			)}

																			<div>
																				<p className="info me-4">
																					{company.companyCategory}
																				</p>
																				<p className="info">
																					{company.companySize}
																				</p>
																			</div>
																		</div>


																		{token === null ? (
																			""
																		) : (
																			<>
																				<div
																					onClick={(e) => {
																						e.preventDefault();
																						e.stopPropagation();
																					}}
																				>
																					<CompanyInteraction Compuid={company.uid}
																						getCompanyList={getAllCompanyList}
																						isBlocked={company.isBlocked} isFollowed={company.isFollowed} />
																				</div>

																			</>
																		)
																		}

																	</div>
																</Link>

															</>
														)
													}
												</div>
											))
										)}
									</div>
								</TabPanel>
							</div>
						</Tabs>
					</div>
				</section>
			</div>
			<Modal show={showUnfollowModal} onHide={handleCloseModal} centered>
				<Modal.Header >
					<Modal.Title> Unfollow</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to Unfollow Company</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={handleConfirmUnfollow} className="btn btn-danger me-2">Confirm</button>

				</Modal.Footer>

			</Modal>
		</>
	)
}

export default AllCompanies